<template>
            <v-card
          class="pa-2"
          outlined
          tile
        >
           <v-overlay absolute :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
        <span>Files</span>
         <v-btn icon @click='fetchFiles'>
        <v-icon title='refresh the list' >refresh</v-icon>
        </v-btn>
         <v-list dense>
           <v-list-item-group color="primary">
         <v-list-item @click='getFileURL(file)' :key='index' v-for='(file,index) in filesList'>
      <v-list-item-content>
        <v-list-item-title><v-icon>save</v-icon>{{formaFileName(file.fileName)}}</v-list-item-title>
        <v-list-item-subtitle>{{$moment(file.metaData.timeCreated).format("MM/DD/YYYY hh:mm:ss")}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
           </v-list-item-group>
         </v-list>
        </v-card>
</template>

<script>
import { postReq} from '../../../helper/firestore'

export default {
    props : {
        filesList : Array
    },
    data() {
        return {
           overlay : false
        }
    },
    methods : {
      fetchFiles(){
        this.overlay = true
        this.$emit('uploadcomplete')
        setTimeout(()=>{ this.overlay = false }, 2500);
      },
         formaFileName(fileName){
        var last  = fileName.split("/").pop();
        return last
      },
             getFileURL(fileName){
        postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/patients/getFileURL',{url : fileName.fileName},(response)=>{
           var a = document.createElement("a");
            a.href = response.data;
            a.setAttribute('target','blank')
            a.click();
        })
      },
    }
}
</script>